import { Stack } from "@mui/material";
import { TextMd } from "Components/Text";
import { FarmCardType } from "types/farm-info";
import FarmInfors from "./FarmInfors";
import { ReportButton } from "Components/Button";
import { REPORT_TYPE } from "constants/data";
import ListingChip from "Components/chips/ListingChip";
import Row from "Components/Row";
import { SendMessageButton } from "Components/button/index";
import BuyerVerfifyTooltip from "Components/tooltip/BuyerVerifyTooltip";
import { useIntl } from "react-intl";
import {
  GreenButton,
} from "Components";
import { scrollToElement } from "helpers/browser";
import { EmailIcon } from "Assets/icons";
import { useEffect, useState, Fragment } from "react";
import { useLocation } from "react-router-dom";

type Props = {
  contact_id?: string;
  buyerDetail?: FarmCardType;
  buyerCardDetail: FarmCardType;
  onBonusGetContact?: () => void;
  fullLink?: boolean;
  isBiz?: boolean;
  onBonus?: () => void;
  disabledLink?: boolean;
  showInfors?: boolean;
  is_expired?: boolean;
};

const FreeBuyerContact = (props: Props) => {
  const {
    buyerCardDetail,
    fullLink,
    disabledLink,
    is_expired,
  } = props;
  const t = useIntl();

  const {
    customer_id,
    customer_name,
    activity_tags = [],
    identity,
    is_biz_verified,
    is_verified_work_email,
    enabled,
  } = buyerCardDetail || {};

  const location = useLocation();
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  
  const enable = enabled === 1 ? true : false;

  const handleScollToInquiry = () => {
    if (enable || !is_expired) {
      scrollToElement("inquiry-form");
    } else {
      scrollToElement("inquiry-form", 'center');
    }
  };
    useEffect(() => {
      if (document.readyState === "complete") {
        setIsPageLoaded(true);
      } else {
        window.addEventListener("load", () => setIsPageLoaded(true));
      }
    }, []);
  
    useEffect(() => {
      const isScroll = queryParams.get("isScroll") === "true";
      if (isScroll && isPageLoaded ) {
        setTimeout(() => {
          handleScollToInquiry();
        }, 1000);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [queryParams, isPageLoaded]);

  return (
    <Fragment>
      <Row spacing={0.5} mb={0.5} minHeight={12} justifyContent={"space-between"}>
        <TextMd color={'white'}>{t.formatMessage({id: "Free_Supplier"})}</TextMd>
        <BuyerVerfifyTooltip
          data={{ is_biz_verified, is_verified_work_email , isCard: true}}
        />
      </Row>

      <Stack className="card border" spacing={1} marginTop={'8px !important'}>
          <Stack spacing={1}>
            <Stack direction="row" alignItems="flex-start" gap={1}>
              <FarmInfors
                company={buyerCardDetail}
                {...{ fullLink, disabledLink }}
              />
              <ReportButton
                type={REPORT_TYPE.buyer}
                title={customer_name}
                reference_name={customer_id}
              />
            </Stack>
            <ListingChip tags={activity_tags} maxHeight="auto" styleCss={{backgroundColor: 'var(--Gray-100, rgba(242, 244, 247, 1))', color: 'rgba(52, 64, 84, 1)'}} />
          </Stack>
          <Fragment>
            <Row justifyContent="center" className="action-box">
              <GreenButton onClick={() => handleScollToInquiry()} style={{backgroundColor: (0) ? '#98A2B3' : '', color: 'white'}}>
                {t.formatMessage({ id: "inquiry_now" })}
                <EmailIcon color="white" style={{marginLeft: 9}}/>
              </GreenButton>
                {(enable || !is_expired) && <SendMessageButton {...{ identity, inBiz: true }} />}
            </Row>
          </Fragment>
      </Stack>
    </Fragment>
  );
};

export default FreeBuyerContact;
